<template>
  <LazyLoadSalesFloorWidget
    :path="path"
    :target-element="targetElement"
    :teleport-disabled="teleportDisabled"
    :toggle="showWidget"
    @load-widget="toggleLoader = true"
  />
  <Skeleton
    v-if="showLoader"
    :class="[virtualAdvisorSkeletonClass]"
    v-bind="skeletonLoaderProps"
  />
</template>

<script setup>
/* istanbul ignore file */
// TODO: Create test file

import {
  ref, computed, provide, onMounted,
} from 'vue';

import Skeleton from '@atomic-ui/skeleton';

import { COMPONENT_PATHS } from '../../constants/SalesFloor';
import useEnvProps from '../../composables/env-props/useEnvProps';
import useRequest from '../../../isolation/composables/useRequest';
import useVirtualAdvisor from '../../composables/contextual/useVirtualAdvisor';
import LazyLoadSalesFloorWidget from './LazyLoadSalesFloorWidget';

// eslint-disable-next-line
const props = defineProps({
  widgetType: { type: String, default: '' },
  widgetName: { type: String, default: '' },
  targetElement: { type: String, default: 'body' },
  teleportDisabled: { type: Boolean, default: false },
  virtualAdvisorWidgetName: { type: String, default: 'expanded' },
  isRegistry: { type: Boolean, default: false },
  brandData: { type: Object, default: () => ({}) },
  specialtyData: { type: Object, default: () => ({}) },
});

// provide props
provide('virtualAdvisorWidgetName', computed(() => props.virtualAdvisorWidgetName));
provide('widgetName', computed(() => props.widgetName));
provide('isRegistry', computed(() => props.isRegistry));
provide('brandData', computed(() => props.brandData));
provide('specialtyData', computed(() => props.specialtyData));

const { entryPoint } = useEnvProps();
const { getData } = useRequest({ type: 'liveStatus', entryPoint: entryPoint?.value });
const {
  virtualAdvisorLoaderProps,
  virtualAdvisorSkeletonClass,
} = useVirtualAdvisor(props);

const liveStatus = ref(false);
const liveStatusComplete = ref(false);
const toggleLoader = ref(false);

const path = computed(() => COMPONENT_PATHS?.[props.widgetType]?.[props.widgetName] || '');
const isVirtualAdvisor = computed(() => props.widgetName === 'virtualAdvisorWidget');
const showWidget = computed(() => (isVirtualAdvisor.value ? toggleLoader.value : liveStatusComplete.value));
const showLoader = computed(() => isVirtualAdvisor.value && !toggleLoader.value);
const skeletonLoaderProps = computed(() => ({
  ...(isVirtualAdvisor.value && virtualAdvisorLoaderProps),
}));

// provide ref values
provide('entryPoint', entryPoint);
provide('liveStatus', liveStatus);
provide('liveStatusComplete', liveStatusComplete);
provide('isVirtualAdvisor', isVirtualAdvisor);

onMounted(() => {
  getData({ pathType: 'availabilities' })
    .then((status) => {
      liveStatus.value = !!status;
    }).finally(() => {
      liveStatusComplete.value = true;
    });
});
</script>

<style lang="scss" scoped>
// Import Common Mixins
@import '../../scss/common/mixins/index.scss';
.skeleton-loader {
  @include margin-top-xs;
}
</style>
